import { connect } from 'react-redux';
import { getTopProductsData, getTopProductsTotal } from '../selectors';
import PieChartWithLegend from '../../components/PieChartWithLegend';

const TopSalesByProduct = connect(state => ({
  title: 'Top sales by product - Top 5',
  data: getTopProductsData(state),
  total: getTopProductsTotal(state),
  automationId: 'topSalesByProduct',
}))(PieChartWithLegend);

export default TopSalesByProduct;
